import { render } from "./Blank.vue?vue&type=template&id=7975625e&ts=true"
import script from "./Blank.vue?vue&type=script&lang=ts"
export * from "./Blank.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__